<device-table>
  <div class="device-table-container">
    <!-- Search and filters -->
    <div class="table-controls mb-3">
      <div class="row g-2">
        <div class="col-md-6 col-lg-8">
          <input
            type="text"
            class="form-control"
            placeholder="Buscar por nombre, ciudad o usuario..."
            value={ state.searchTerm }
            oninput={ handleSearch }
          />
        </div>
        <div class="col-md-3 col-lg-2">
          <select class="form-select" value={ state.statusFilter } onchange={ handleStatusFilter }>
            <option value="all">Todos los estados</option>
            <option value="online">Solo Online</option>
            <option value="offline">Solo Offline</option>
          </select>
        </div>
        <div class="col-md-3 col-lg-2">
          <select class="form-select" value={ state.pageSize } onchange={ handlePageSizeChange }>
            <option value="10">10 por página</option>
            <option value="25">25 por página</option>
            <option value="50">50 por página</option>
            <option value="100">100 por página</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="table-responsive">
      <table class="table table-hover table-striped device-table">
        <thead class="table-light">
          <tr>
            <th if={ props.isAdmin } class="sortable" onclick={ () => handleSort('ownerName') }>
              Usuario
              <i class="bi bi-{ getSortIcon('ownerName') } ms-1"></i>
            </th>
            <th class="sortable" onclick={ () => handleSort('city') }>
              Ciudad
              <i class="bi bi-{ getSortIcon('city') } ms-1"></i>
            </th>
            <th class="sortable" onclick={ () => handleSort('name') }>
              Nombre
              <i class="bi bi-{ getSortIcon('name') } ms-1"></i>
            </th>
            <th class="sortable" onclick={ () => handleSort('lastConnection') }>
              Última Conexión
              <i class="bi bi-{ getSortIcon('lastConnection') } ms-1"></i>
            </th>
            <th class="sortable" onclick={ () => handleSort('online') }>
              Estado
              <i class="bi bi-{ getSortIcon('online') } ms-1"></i>
            </th>
            <th class="text-center">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr if={ paginatedDevices.length === 0 }>
            <td colspan={ props.isAdmin ? 6 : 5 } class="text-center text-muted py-4">
              <i class="bi bi-inbox fs-1 d-block mb-2"></i>
              { state.searchTerm || state.statusFilter !== 'all'
                ? 'No se encontraron dispositivos con los filtros aplicados'
                : 'No hay dispositivos disponibles'
              }
            </td>
          </tr>
          <tr each={ device in paginatedDevices } class="device-row">
            <td if={ props.isAdmin }>
              <div>
                <i class="bi bi-person-fill me-1"></i>
                <strong>{ device.ownerName || 'N/A' }</strong>
              </div>
              <small class="text-muted">{ device.user || 'N/A' }</small>
            </td>
            <td>
              <i class="bi bi-geo-alt-fill me-1"></i>
              { device.city || 'N/A' }
            </td>
            <td>
              <strong>{ device.name }</strong>
              <br>
              <small class="text-muted">{ device._id }</small>
            </td>
            <td title={ formatDate(device.lastConnection) }>
              { formatLastConnection(device.lastConnection) }
            </td>
            <td>
              <span class="badge bg-{ isDeviceOnline(device) ? 'success' : 'danger' }">
                <i class="bi bi-{ isDeviceOnline(device) ? 'wifi' : 'wifi-off' } me-1"></i>
                { isDeviceOnline(device) ? 'Online' : 'Offline' }
              </span>
            </td>
            <td class="text-center table-actions-cell">
              <div class="btn-group table-action-group" role="group" aria-label="Acciones del dispositivo">
                <button
                  class="btn btn-sm table-action-btn table-action-view"
                  onclick={ () => handleViewDetails(device._id) }
                  title="Ver detalles"
                >
                  <i class="bi bi-eye"></i>
                </button>
                <button
                  class="btn btn-sm table-action-btn table-action-edit"
                  onclick={ () => handleEditDevice(device._id) }
                  title="Editar dispositivo"
                >
                  <i class="bi bi-pencil"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <nav if={ totalPages > 1 } aria-label="Paginación de dispositivos">
      <ul class="pagination justify-content-center">
        <li class="page-item { state.currentPage === 1 ? 'disabled' : '' }">
          <a class="page-link" href="#" onclick={ (e) => handlePageChange(e, 1) }>
            <i class="bi bi-chevron-double-left"></i>
          </a>
        </li>
        <li class="page-item { state.currentPage === 1 ? 'disabled' : '' }">
          <a class="page-link" href="#" onclick={ (e) => handlePageChange(e, state.currentPage - 1) }>
            <i class="bi bi-chevron-left"></i>
          </a>
        </li>

        <li each={ page in visiblePages } class="page-item { state.currentPage === page ? 'active' : '' }">
          <a class="page-link" href="#" onclick={ (e) => handlePageChange(e, page) }>
            { page }
          </a>
        </li>

        <li class="page-item { state.currentPage === totalPages ? 'disabled' : '' }">
          <a class="page-link" href="#" onclick={ (e) => handlePageChange(e, state.currentPage + 1) }>
            <i class="bi bi-chevron-right"></i>
          </a>
        </li>
        <li class="page-item { state.currentPage === totalPages ? 'disabled' : '' }">
          <a class="page-link" href="#" onclick={ (e) => handlePageChange(e, totalPages) }>
            <i class="bi bi-chevron-double-right"></i>
          </a>
        </li>
      </ul>
      <p class="text-center text-muted small">
        Mostrando { startIndex + 1 } - { Math.min(endIndex, state.filteredDevices.length) } de { state.filteredDevices.length } dispositivos
      </p>
    </nav>

  </div>

  <script>
    import { isDeviceOnline, formatLastConnection, formatDate } from '../utils/device-utils';

    export default {
      onBeforeMount() {
        this.state = {
          searchTerm: '',
          sortColumn: 'city',
          sortDirection: 'asc',
          statusFilter: 'all',
          filteredDevices: [],
          currentPage: 1,
          pageSize: 25
        };
      },

      onMounted() {
        this.filterAndSortDevices();
      },

      onUpdated() {
        // Re-filter when devices prop changes
        if (this.props.devices !== this.previousDevices) {
          this.previousDevices = this.props.devices;
          this.filterAndSortDevices();
        }
      },

      // Computed properties
      get paginatedDevices() {
        if (!this.state || !this.state.filteredDevices) {
          return [];
        }
        const start = (this.state.currentPage - 1) * this.state.pageSize;
        const end = start + this.state.pageSize;
        return this.state.filteredDevices.slice(start, end);
      },

      get totalPages() {
        if (!this.state || !this.state.filteredDevices) {
          return 1;
        }
        return Math.ceil(this.state.filteredDevices.length / this.state.pageSize);
      },

      get startIndex() {
        if (!this.state) {
          return 0;
        }
        return (this.state.currentPage - 1) * this.state.pageSize;
      },

      get endIndex() {
        if (!this.state) {
          return 0;
        }
        return this.startIndex + this.state.pageSize;
      },

      get visiblePages() {
        const total = this.totalPages;
        const current = this.state?.currentPage || 1;
        const delta = 2; // Mostrar 2 páginas antes y después de la actual

        const pages = [];
        const start = Math.max(1, current - delta);
        const end = Math.min(total, current + delta);

        for (let i = start; i <= end; i++) {
          pages.push(i);
        }

        return pages;
      },

      // Methods
      filterAndSortDevices() {
        let filtered = [...(this.props.devices || [])];

        // Apply search filter
        if (this.state.searchTerm) {
          const term = this.state.searchTerm.toLowerCase();
          filtered = filtered.filter(d =>
            d.name?.toLowerCase().includes(term) ||
            d.city?.toLowerCase().includes(term) ||
            d.ownerName?.toLowerCase().includes(term) ||
            d.user?.toLowerCase().includes(term) ||
            d._id?.toLowerCase().includes(term)
          );
        }

        // Apply status filter
        if (this.state.statusFilter !== 'all') {
          filtered = filtered.filter(d => {
            const online = this.isDeviceOnline(d);
            return this.state.statusFilter === 'online' ? online : !online;
          });
        }

        // Apply sorting
        filtered.sort((a, b) => {
          let aVal, bVal;

          if (this.state.sortColumn === 'online') {
            aVal = this.isDeviceOnline(a) ? 1 : 0;
            bVal = this.isDeviceOnline(b) ? 1 : 0;
          } else {
            aVal = a[this.state.sortColumn];
            bVal = b[this.state.sortColumn];
          }

          // Handle null/undefined values
          if (aVal === null || aVal === undefined) aVal = '';
          if (bVal === null || bVal === undefined) bVal = '';

          const mult = this.state.sortDirection === 'asc' ? 1 : -1;

          if (typeof aVal === 'string' && typeof bVal === 'string') {
            return aVal.localeCompare(bVal) * mult;
          }

          return (aVal > bVal ? 1 : aVal < bVal ? -1 : 0) * mult;
        });

        // Reset to page 1 if current page is now invalid
        const newTotalPages = Math.ceil(filtered.length / this.state.pageSize);
        if (this.state.currentPage > newTotalPages && newTotalPages > 0) {
          this.update({ currentPage: 1 });
        }

        this.update({ filteredDevices: filtered });
      },

      handleSearch(e) {
        this.update({ searchTerm: e.target.value, currentPage: 1 });
        this.filterAndSortDevices();
      },

      handleStatusFilter(e) {
        this.update({ statusFilter: e.target.value, currentPage: 1 });
        this.filterAndSortDevices();
      },

      handlePageSizeChange(e) {
        this.update({
          pageSize: parseInt(e.target.value, 10),
          currentPage: 1
        });
        this.filterAndSortDevices();
      },

      handleSort(column) {
        const newDirection =
          this.state.sortColumn === column && this.state.sortDirection === 'asc'
            ? 'desc'
            : 'asc';

        this.update({
          sortColumn: column,
          sortDirection: newDirection
        });

        this.filterAndSortDevices();
      },

      getSortIcon(column) {
        if (this.state.sortColumn !== column) {
          return 'arrow-down-up';
        }
        return this.state.sortDirection === 'asc' ? 'arrow-up' : 'arrow-down';
      },

      handlePageChange(e, page) {
        e.preventDefault();
        if (page >= 1 && page <= this.totalPages) {
          this.update({ currentPage: page });
        }
      },

      isDeviceOnline(device) {
        return isDeviceOnline(device);
      },

      formatLastConnection(timestamp) {
        return formatLastConnection(timestamp);
      },

      formatDate(timestamp) {
        return formatDate(timestamp);
      },

      handleViewDetails(deviceId, e) {
        if (e) {
          e.preventDefault();
        }
        if (this.props.onviewdetails) {
          this.props.onviewdetails(deviceId);
        }
      },

      handleEditDevice(deviceId) {
        window.history.pushState({}, '', `/create-device?id=${deviceId}`);
        window.dispatchEvent(new PopStateEvent('popstate'));
      }
    }
  </script>
</device-table>
